module.exports = "/images/icon_reviewstar_active.png?f38ba5ad097a083c9f8176b5e31beed3";